<script>
import { isRemovedFeature } from '@/removableFeatures';

/**
 * @description Убираемый по функциональности компонент.
 * @type {Vue}
 */
export default {
  functional: true,
  name: 'RemovableFeature',
  props: {
    feature: {
      required: true,
      type: String,
    },
  },
  render(createElement, { children, props: { feature } }) {
    if (isRemovedFeature(feature)) {
      return createElement();
    }
    return children;
  },
};
</script>
